import React, { useState } from 'react';
import { cn } from '@/lib/utils';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './EnhancedMainLayout.css';

interface EnhancedMainLayoutProps {
  children: React.ReactNode;
  sidebar?: React.ReactNode;
  infoPanel?: React.ReactNode;
  className?: string;
  enableSidebarCollapse?: boolean;
  zenMode?: boolean;
  onToggleZenMode?: () => void;
}

const EnhancedMainLayout: React.FC<EnhancedMainLayoutProps> = ({ 
  children, 
  sidebar, 
  infoPanel,
  className,
  enableSidebarCollapse = true,
  zenMode = false,
  onToggleZenMode
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const handleToggleSidebar = () => {
    if (enableSidebarCollapse) {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  return (
    <div className={cn('enhanced-main-layout', zenMode && 'zen-mode', className)}>
      {/* Background Pattern */}
      <div className="layout-background" />
      
      {/* Sidebar - Hidden in zen mode */}
      {sidebar && !zenMode && (
        <div className={cn('layout-sidebar', sidebarCollapsed && 'collapsed')}>
          {sidebar}
        </div>
      )}

      {/* Main Content Area */}
      <main className={cn(
        'layout-main', 
        sidebarCollapsed && 'sidebar-collapsed',
        zenMode && 'zen-mode'
      )}>
        <div className="main-content-wrapper">
          {children}
        </div>
      </main>
      
      {/* Info Panel - Hidden in zen mode */}
      {infoPanel && !zenMode && (
        <div className="layout-info-panel">
          {infoPanel}
        </div>
      )}
      
      {/* Mobile Overlay */}
      {!sidebarCollapsed && !zenMode && (
        <div 
          className="mobile-sidebar-overlay"
          onClick={handleToggleSidebar}
        />
      )}
    </div>
  );
};

export default EnhancedMainLayout;
